import React, { FC } from 'react';
import styled from 'styled-components';

import Spacer from '../layout/Spacer';

type LoadingProps = {
  loadingMessage: string;
};

const Loading: FC<LoadingProps> = ({ loadingMessage }) => {
  return (
    <LoadingContainer>
      <s-spinner accessibilityLabel={loadingMessage} />
      <Spacer width={12} />
      <s-heading fontSize='large'>{loadingMessage}</s-heading>
    </LoadingContainer>
  );
};

const LoadingContainer = styled.div`
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Loading;
